import { TOAST_ID } from 'palette/Toast';
import { saveState } from '@helpers/localStorage';
import {
    GET_COLLECTIONS_SUCCESS,
    CREATE_COLLECTION_SUCCESS,
    DELETE_COLLECTION_SUCCESS,
    ADD_TO_COLLECTION_SUCCESS,
    SET_CURRENT_COLLECTION,
    GET_SHARED_COLLECTIONS_SUCCESS,
    GET_SHARED_COLLECTIONS_ERROR,
    GET_SHARED_COLLECTIONS_PENDING,
    SET_CURRENT_VARIANT_IDS,
    SET_TOAST_ID,
    SHOW_COLLECTION_ITEMS,
    GET_COLLECTION_ITEMS_SUCCESS,
    DELETE_MULTIPLE_COLLECTION_SUCCESS,
    RENAME_COLLECTION_SUCCESS,
    SET_ERROR_MESSAGE,
    SET_SUCCESS_MESSAGE,
    SET_COLLECTIONS_LOADING,
    GET_COLLECTION_ITEMS_FILTERS_OPTIONS,
    SET_SORTING_OPTION,
    DATE_DESC,
    DELETE_COLLECTION_ITEMS_SUCCESS,
    DELETE_MULTIPLE_COLLECTION_ITEMS_SUCCESS,
    SET_SELECTED_FILTER_OPTION,
    GET_FAVORITES_SUCCESS,
    COLLECTION_CACHE_NAME
} from '../constants';

const initialState = {
    isLoading: false,
    isSharedCollectionLoading: false,
    collectionList: [],
    currentCollection: null,
    sharedCollection: null,
    currentVariantIds: [],
    showCollectionItems: false,
    collectionItems: [],
    error: null,
    success: null,
    toastId: null,
    collectionItemsFilterOptions: [],
    selectedFilters: [],
    favourites: [],
    sortingOption: DATE_DESC
};

function collections(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_ERROR_MESSAGE: {
            return { ...state, error: payload };
        }

        case SET_SUCCESS_MESSAGE: {
            return { ...state, success: payload };
        }

        case SET_COLLECTIONS_LOADING: {
            return {
                ...state,
                isLoading: payload
            };
        }

        case GET_COLLECTIONS_SUCCESS: {
            return { ...state, collectionList: payload };
        }

        case CREATE_COLLECTION_SUCCESS: {
            return { ...state, success: payload };
        }

        case RENAME_COLLECTION_SUCCESS: {
            return {
                ...state,
                currentCollection: {
                    ...state.currentCollection,
                    name: payload.name,
                    url_hash: payload.url_hash
                }
            };
        }

        case ADD_TO_COLLECTION_SUCCESS: {
            return { ...state, success: payload };
        }

        case DELETE_COLLECTION_SUCCESS: {
            if (!payload.id || !state.collectionList) {
                return {
                    ...state,
                    success: payload.success
                };
            }

            const tempCollectionList = state.collectionList.filter(collection => collection.id !== payload.id);

            saveState(COLLECTION_CACHE_NAME, tempCollectionList);

            return {
                ...state,
                success: payload.success,
                collectionList: tempCollectionList
            };
        }

        case DELETE_MULTIPLE_COLLECTION_SUCCESS: {
            if (!payload.ids || !state.collectionList) {
                return {
                    ...state,
                    success: payload.success
                };
            }

            const tempCollectionList = state.collectionList.filter(collection => !payload.ids.includes(collection.id));

            saveState(COLLECTION_CACHE_NAME, tempCollectionList);

            return {
                ...state,
                success: payload.success,
                collectionList: tempCollectionList
            };
        }

        case DELETE_COLLECTION_ITEMS_SUCCESS: {
            if (!state.currentCollection || !payload || !state.collectionList) {
                return {
                    ...state
                };
            }

            const tempCurrentCollection = state.collectionList.find(collection => collection.id === state.currentCollection.id);

            tempCurrentCollection.items = [...tempCurrentCollection.items
                .filter(collectionItem => collectionItem.variant_id !== payload.toString())];

            const tempCollectionList = state.collectionList.map((collection) => {
                if (collection.id !== tempCurrentCollection.id) {
                    return collection;
                }

                return tempCurrentCollection;
            });

            saveState(COLLECTION_CACHE_NAME, tempCollectionList);

            return {
                ...state,
                currentCollection: tempCurrentCollection,
                collectionList: tempCollectionList
            };
        }

        case DELETE_MULTIPLE_COLLECTION_ITEMS_SUCCESS: {
            if (!state.currentCollection || !payload || !state.collectionList) {
                return {
                    ...state
                };
            }

            const tempCurrentCollection = state.collectionList.find(collection => collection.id === state.currentCollection.id);

            tempCurrentCollection.items = [...tempCurrentCollection.items
                .filter(collectionItem => !payload.includes(collectionItem.variant_id))];

            const tempCollectionList = state.collectionList.map((collection) => {
                if (collection.id !== tempCurrentCollection.id) {
                    return collection;
                }

                return tempCurrentCollection;
            });

            saveState(COLLECTION_CACHE_NAME, tempCollectionList);

            return {
                ...state,
                currentCollection: tempCurrentCollection,
                collectionList: tempCollectionList
            };
        }

        case GET_SHARED_COLLECTIONS_ERROR: {
            return {
                ...state,
                error: payload,
                toastId: TOAST_ID.sharedCollectionToast
            };
        }

        case GET_SHARED_COLLECTIONS_PENDING: {
            return {
                ...state,
                success: null,
                error: null,
                isSharedCollectionLoading: payload
            };
        }

        case GET_SHARED_COLLECTIONS_SUCCESS: {
            return {
                ...state,
                sharedCollection: payload,
                toastId: TOAST_ID.sharedCollectionToast
            };
        }

        case SET_CURRENT_COLLECTION: {
            return { ...state, currentCollection: payload };
        }

        case SET_CURRENT_VARIANT_IDS: {
            return { ...state, currentVariantIds: payload };
        }

        case SET_TOAST_ID: {
            return { ...state, toastId: payload };
        }

        case SET_SORTING_OPTION: {
            return { ...state, sortingOption: payload };
        }

        case SHOW_COLLECTION_ITEMS: {
            return {
                ...state,
                showCollectionItems: payload
            };
        }

        case GET_COLLECTION_ITEMS_SUCCESS: {
            return { ...state, collectionItems: payload };
        }

        case GET_COLLECTION_ITEMS_FILTERS_OPTIONS: {
            return { ...state, collectionItemsFilterOptions: payload };
        }

        case SET_SELECTED_FILTER_OPTION: {
            return { ...state, selectedFilters: payload };
        }

        case GET_FAVORITES_SUCCESS: {
            return { ...state, favourites: payload };
        }

        default:
            return state;
    }
}

export default collections;
